import moment from 'moment'
import React from 'react'
import { useSelector } from 'react-redux'

export function Goals() {
  const { goal_subscriptions, config, organization, resident } = useSelector(state => state)
  const sender = `${config.root_url}organizations/${organization.name}/residents/${resident.id}#goals`

  return (
    <div>
      {
        goal_subscriptions.goal_subscriptions.map(subscription => (
          <a
            key={subscription.id}
            href={`${config.root_url}organizations/${organization.name}/goals/${subscription.goal.id}/edit?sender_name=${resident.name}&sender=${sender}`}
            className="p-4 border-bottom clickable text-black d-block">
            <div className="d-flex justify-content-between align-items-center">
              <b>{subscription.goal.title}</b>
              {
                subscription.completed ?
                  <div className="badge badge-success">COMPLETED</div> :
                  <div className="badge badge-warning">IN PROGRESS</div>
              }
            </div>
            <div className="text-secondary">{!!subscription.goal.due && moment(subscription.goal.due).format("MM/DD/YY hh:mma")}</div>
          </a>
        ))
      }
    </div>
  )
}
